import React, { useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import block from 'bem-cn'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'

import { ModalContext } from 'components/HOC/withModalQuery/ModalContext'

import SpinIconSVG from '../img/spin-icon.svg'

import './WheelButton.scss'

const b = block('wheel-button')

const WheelButton = ({ className, onCloseProfileMenu }) => {
  const { pushNewModal } = useContext(ModalContext)

  const onRouletteIconClick = useCallback(() => {
    pushNewModal(MODAL_ROUTE_URLS.WHEEL_GAME())()
    if (onCloseProfileMenu) {
      onCloseProfileMenu()
    }
  }, [pushNewModal, onCloseProfileMenu])

  return <img src={SpinIconSVG} alt="spin-icon" onClick={onRouletteIconClick} className={b.mix(className)} />
}

WheelButton.propTypes = {
  className: PropTypes.string,
  onCloseProfileMenu: PropTypes.func,
}

WheelButton.defaultProps = {
  className: '',
  onCloseProfileMenu: undefined,
}

export default WheelButton
